import Controller from '../abstracts/Controller';
import 'scss-templates/t-listing.scss';

export default class ListingController extends Controller {
  static get COMPONENTS() {
    return [
      'FiltersComponent',
      'PriceRangeComponent',
      'ShortcutComponent',
      'ListingHeadComponent',
      'CategoryFilterComponent',
      'SearchComponent',
      'PaginationComponent',
      'ProductCardSwatchesComponent',
      'CarouselComponent',
      'RecommendationEngineComponent',
      'ListingEditorialComponent',
      'WishlistComponent',
      'VisualMerchandisingComponent',
      'HistoryManagerComponent',
      'SaleRangeComponent',
      'ListingCarouselComponent',
      'JournalComponent',
      'InfiniteScrollTextComponent',
      'InspiredComponent',
      'ActiveFiltersComponent'
    ];
  }
}
